module.exports = __webpack_public_path__ + "img/6-4.cdd6bcb1.png";